import api from './api';

export type ProcuracaoStatus = 'PENDENTE' | 'ATIVA' | 'RECUSADA' | 'REVOGADA' | 'RENUNCIADA' | 'EXPIRADA';

export interface Procuracao {
  id: string;
  instituicaoId: string;
  instituicaoNome?: string;
  outorganteNome?: string;
  outorganteDocumento?: string;
  procuradorNome?: string;
  procuradorDocumento?: string;
  status: ProcuracaoStatus;
  dataInicio: string;
  dataFim: string;
  criadaEm: string;
  aceitaEm?: string;
  encerradaEm?: string;
}

const procuracaoService = {
  async perfil(): Promise<{ podeConceder: boolean; visaoAdmin: boolean }> {
    const { data } = await api.get('/procuracoes/perfil');
    return data;
  },
  async concedidas(): Promise<Procuracao[]> {
    const { data } = await api.get('/procuracoes/concedidas');
    return data;
  },
  async recebidas(): Promise<Procuracao[]> {
    const { data } = await api.get('/procuracoes/recebidas');
    return data;
  },
  async criar(cpfProcurador: string, dataFim: string): Promise<Procuracao> {
    const { data } = await api.post('/procuracoes', { cpfProcurador, dataFim });
    return data;
  },
  async aceitar(id: string): Promise<void> { await api.post(`/procuracoes/${id}/aceitar`); },
  async recusar(id: string): Promise<void> { await api.post(`/procuracoes/${id}/recusar`); },
  async revogar(id: string): Promise<void> { await api.post(`/procuracoes/${id}/revogar`); },
  async renunciar(id: string): Promise<void> { await api.post(`/procuracoes/${id}/renunciar`); },
};

export default procuracaoService;
